import api from '@/api'
import i18n from '@/i18n'

export default {
  namespaced: true,
  state: {
    languages: [],
    language: {
      label: '简体中文',
      value: 'cn',
    },
    oss: {
      domain: 'https://abs-oss.oss-cn-shanghai.aliyuncs.com/'
    }
  },
  actions: {
    async languagesLoad({ commit }) {
      const { body } = await api.SYS_LOCALES_LIST()
      if (body && body.data) {
        commit('setlanguages', body.data)
        commit('setLanguage', body.data.find(item => item.value === i18n.locale))
      }
    },
    async load({ dispatch }) {
      await dispatch('languagesLoad')
    },
  },
  mutations: {
    setlanguages(state, languages) {
      state.languages = languages
    },
    setLanguage(state, language) {
      if (language) {
        state.language = language
      }
    },
  },
}
